import CompanyDescriptionInput from './CompanyDescriptionInput';

export default CompanyDescriptionInput;
